import { API_URL } from '../constants/api';
import { CURRENCIES, DEFAULT_CURRENCY } from '../constants/currencies';

const API = `${API_URL}/api`;

// Detect currency from IP via ipapi.co, save to user profile, return the code.
// Only runs when the user has no currency set yet.
export async function detectAndSaveCurrency(token) {
  try {
    const geo = await fetch('https://ipapi.co/json/', { signal: AbortSignal.timeout(5000) });
    if (!geo.ok) return DEFAULT_CURRENCY;

    const { currency } = await geo.json();
    const code = currency && CURRENCIES[currency] ? currency : DEFAULT_CURRENCY;

    await fetch(`${API}/users/me/profile`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ currency: code }),
    });

    return code;
  } catch {
    return DEFAULT_CURRENCY;
  }
}
